import { render, staticRenderFns } from "./EvoucherMainPage.vue?vue&type=template&id=2c1ed632&scoped=true&"
import script from "./EvoucherMainPage.vue?vue&type=script&lang=js&"
export * from "./EvoucherMainPage.vue?vue&type=script&lang=js&"
import style0 from "./EvoucherMainPage.vue?vue&type=style&index=0&id=2c1ed632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ed632",
  null
  
)

export default component.exports